module.exports = __webpack_public_path__ + "static/media/AEHS-Logo.e24cb4ae.png";